import { CheckBox } from "../core/components/checkBox.js";
import { FAIcon } from "../core/components/faIcon.js";
import { FieldInstance } from "../core/components/field.js";
import { TextBox } from "../core/components/textBox.js";
import { Helper } from "../core/util/helper.js";
import { SkillFilter } from "../generalSettings/skills/skillsInterfaces.js";
import React from "react";
export class SkillTreeFilterApp extends React.Component<{
    disabled: boolean;
    skillFilter: SkillFilter;
    onFilterChanged: (filter: SkillFilter) => void;
}, {
    skillFilter: SkillFilter;
}>{
    constructor(props) {
        super(props);
        this.state = {
            skillFilter: this.props.skillFilter
        }
    }

    componentDidMount() {
        this.onFilterChanged();
    }

    private onFilterChanged = () => {
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(this.state.skillFilter);
        }
    }

    private _setFilterWithSkills = (value: boolean) => {
        let skillFilter = this.state.skillFilter;
        skillFilter.ShowOnlyCatsWithValues = value;
        this.setState({ skillFilter: skillFilter }, this.onFilterChanged);
    }

    private _setFilterOnlyFilled = (value: boolean) => {
        let skillFilter = this.state.skillFilter;
        skillFilter.ShowOnlyCatsWithSkills = value;
        this.setState({ skillFilter: skillFilter }, this.onFilterChanged);
    }

    private _setFilter = (value: string) => {
        let skillFilter = this.state.skillFilter;
        skillFilter.Text = value;
        this.setState({ skillFilter: skillFilter }, this.onFilterChanged);
    }

    render() {
        return (
            <div className="skills-wrapper__filter" style={{ margin: "5px" }}>
                <FieldInstance noLabel={true}>
                    <CheckBox
                        field={{ type: "n/a", model: "categoryWithSkills", name: Helper.getTranslation("Skills.HasSkills"), labelAndControlCombined: true }}
                        value={this.state.skillFilter.ShowOnlyCatsWithValues}
                        onChange={(f, v) => this._setFilterWithSkills(v)}
                        disabled={this.props.disabled}
                    />
                </FieldInstance>
                <FieldInstance noLabel={true}>
                    <CheckBox
                        field={{ type: "n/a", model: "onlyFilledcategories", name: Helper.getTranslation("Skills.OnlyFilledCategories"), labelAndControlCombined: true }}
                        value={this.state.skillFilter.ShowOnlyCatsWithSkills}
                        onChange={(f, v) => this._setFilterOnlyFilled(v)}
                        disabled={this.props.disabled}
                    />
                </FieldInstance>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <FAIcon name="fas fa-search" attributes={[""]} style={{ margin: "5px", color: !this.props.disabled ? "black" : "#a6a6a6" }} />
                    <div style={{ width: "280px" }}>
                        <TextBox field={{ type: "n/a", model: "filter", triggerOnChange: true }} value={this.state.skillFilter.Text} onChange={(f, v) => this._setFilter(v)} disabled={this.props.disabled} />
                    </div>
                </div>
            </div>)
    }
}